import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-white flex flex-col">

      <div className="flex justify-between items-center px-6 py-4 border-b border-white/10">
          <Link to="/">
            <img
              src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png"
              alt="Beem Logo"
              className="w-28"
              style={{ cursor: 'pointer' }}
            />
          </Link>
      </div>

      <div className="flex justify-center px-6 py-12">
        <div className="max-w-3xl w-full">

          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-gray-400 mb-8">
            Effective date: 09/06/2026
          </p>

          <div className="space-y-8 text-gray-300 text-sm leading-relaxed">

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">1. Who We Are</h2>
              <p>
                Beem Tech Limited (“we”, “us”, or “our”) operates the Beem waitlist and is committed
                to protecting your personal data.
              </p>
              <p className="mt-2">
                If you have any questions, contact us at:
                <br />
                📧 wjelson@beemtech.co.uk
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">2. What Data We Collect</h2>
              <p>When you join our waitlist, we collect:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Your name</li>
                <li>Your email address</li>
                <li>Your marketing preferences (if you opt in)</li>
              </ul>
              <p className="mt-2">We do not collect sensitive personal data.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">3. How We Use Your Data</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Add you to the Beem waitlist</li>
                <li>Notify you when Beem launches</li>
                <li>Provide early access or login details</li>
                <li>Send product updates (if you opt in)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">4. Legal Basis</h2>
              <p>We process your data under UK GDPR based on:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Consent — when you submit your details</li>
                <li>Legitimate interest — to manage the waitlist</li>
              </ul>
              <p className="mt-2">You can withdraw consent at any time.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">5. Data Storage</h2>
              <p>
                Your data is securely stored using Supabase. We take appropriate technical and
                organisational measures to protect your information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">6. Data Retention</h2>
              <p>
                We retain your data until Beem launches and onboarding is complete, or until you
                request deletion.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">7. Sharing Your Data</h2>
              <p>
                We do not sell your data. We only share it with trusted providers necessary to run
                the waitlist (e.g. Supabase).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">8. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Access your data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion</li>
                <li>Withdraw consent</li>
              </ul>
              <p className="mt-2">
                To exercise these rights, contact:
                <br />
                📧 wjelson@beemtech.co.uk
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">9. Marketing</h2>
              <p>
                If you opt in, we may send product updates and launch emails. You can unsubscribe at
                any time.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">10. Cookies</h2>
              <p>
                We do not currently use cookies or tracking technologies. If this changes, this page
                will be updated.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">11. Updates</h2>
              <p>
                We may update this policy from time to time. Significant changes will be clearly
                communicated.
              </p>
            </section>

          </div>
        </div>
      </div>

      <div className="text-center text-xs text-gray-500 py-6 border-t border-white/10">
        © {new Date().getFullYear()} Beem Tech Limited
      </div>
    </div>
  );
}
